import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  EDITSUBSCRIPTION,
  SUBSCRIPTIONDETAIL,
} from "../../../../store/subscription/actions";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";

const STATIC_LANGUAGE_ID = "688088b3556ad0e02478cc51";

const EditSubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading } = useSelector((state) => state.Subscription);

  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    monthlyPrice: "",
    interval: "",
    intervalCount: "",
    originalPrice: "",
    status: "active",
    stripePriceId: "",
    tokens: "",
    translations: [
      {
        language: STATIC_LANGUAGE_ID,
        name: "",
        badge: "",
        benifits: [""],
      },
    ],
  });
  console.log(id, "dididi");

  // ── Fetch plan details ──
  const getPlanDetails = () => {
    const callback = (err, res) => {
      if (err) {
        console.error(err);
        toast.error(err);
      } else {
        const plan = res.data;
        console.log(plan, "checking plan");
        setFormData({
          id: plan?._id || "",
          monthlyPrice: plan?.monthlyPrice || "",
          interval: plan?.interval || "",
          intervalCount: plan?.intervalCount || "",
          originalPrice: plan?.originalPrice || "",
          stripePriceId: plan?.stripePriceId || "",
          tokens: plan?.tokens || "",
          status: plan?.status || "active",
          translations:
            Array.isArray(plan?.translations) && plan.translations.length > 0
              ? plan.translations.map((t) => ({
                  language: STATIC_LANGUAGE_ID,
                  name: t?.name || "",
                  badge: t?.badge || "",
                  benifits:
                    Array.isArray(t?.benifits) && t.benifits.length > 0
                      ? t.benifits
                      : [""],
                }))
              : [
                  {
                    language: STATIC_LANGUAGE_ID,
                    name: "",
                    badge: "",
                    benifits: [""],
                  },
                ],
        });
      }
    };
    dispatch(SUBSCRIPTIONDETAIL({ data: id, callback }));
  };

  useEffect(() => {
    getPlanDetails();
  }, []);

  // ── Global field handler ──
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "number") {
      if (value === "") {
        setFormData({ ...formData, [name]: "" });
        setErrors({ ...errors, [name]: "" });
        return;
      }
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) return;
      setFormData({ ...formData, [name]: numericValue });
    } else {
      if (name === "interval") {
        setFormData({ ...formData, interval: value, intervalCount: "" });
      } else {
        setFormData({
          ...formData,
          [name]: type === "checkbox" ? checked : value,
        });
      }
    }
    setErrors({ ...errors, [name]: "" });
  };

  // ── Translation field handler ──
  const handleTranslationChange = (index, field, value) => {
    const updated = [...formData.translations];
    updated[index] = { ...updated[index], [field]: value };
    setFormData({ ...formData, translations: updated });
    setErrors((prev) => ({ ...prev, [`translations-${index}-${field}`]: "" }));
  };

  // ── Benefit handlers per translation ──
  const handleBenifitChange = (tIndex, bIndex, value) => {
    const updated = formData.translations.map((t, i) => {
      if (i !== tIndex) return t;
      const newBenifits = [...t.benifits];
      newBenifits[bIndex] = value;
      return { ...t, benifits: newBenifits };
    });
    setFormData({ ...formData, translations: updated });
  };

  const addBenifit = (tIndex) => {
    const updated = formData.translations.map((t, i) =>
      i === tIndex ? { ...t, benifits: [...t.benifits, ""] } : t,
    );
    setFormData({ ...formData, translations: updated });
  };

  const removeBenifit = (tIndex, bIndex) => {
    const updated = formData.translations.map((t, i) => {
      if (i !== tIndex) return t;
      return { ...t, benifits: t.benifits.filter((_, bi) => bi !== bIndex) };
    });
    setFormData({ ...formData, translations: updated });
  };

  // ── Interval count options ──
  const getIntervalCountOptions = () => {
    if (formData.interval === "year") return [{ value: "1", label: "1" }];
    if (formData.interval === "month")
      return [
        { value: "1", label: "1" },
        { value: "3", label: "3" },
        { value: "12", label: "12" },
      ];
    return [];
  };

  // ── Validation ──
  const validateFormData = () => {
    const newErrors = {};
    if (!formData.monthlyPrice)
      newErrors.monthlyPrice = "Monthly Price is required";
    if (!formData.interval) newErrors.interval = "Interval is required";
    if (!formData.intervalCount)
      newErrors.intervalCount = "Interval count is required";

    formData.translations.forEach((t, index) => {
      if (!t.name)
        newErrors[`translations-${index}-name`] = "Plan name is required";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ── Submit ──
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    if (!validateFormData()) {
      setIsDisabled(false);
      return;
    }
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          console.error(err);
        } else {
          toast.success("Plan Updated Successfully");
          navigate("/subscription-setting");
        }
        setIsDisabled(false);
      };
      dispatch(EDITSUBSCRIPTION({ data: formData, callback }));
    } catch (error) {
      console.error(error, "<===err");
      setIsDisabled(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form className="mx-auto" onSubmit={handleSubmit}>
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Edit Subscription:
                      </h5>
                    </div>
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        {/* Monthly Price */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Monthly Price
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="monthlyPrice"
                            placeholder="Enter monthly price"
                            value={formData.monthlyPrice}
                            onChange={handleChange}
                          />
                          {errors.monthlyPrice && (
                            <small className="text-danger">
                              {errors.monthlyPrice}
                            </small>
                          )}
                        </Col>

                        {/* Original Price */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Original Price
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="originalPrice"
                            placeholder="Enter original price"
                            value={formData.originalPrice}
                            onChange={handleChange}
                          />
                        </Col>

                        {/* Tokens */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Tokens
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="tokens"
                            placeholder="Enter Tokens"
                            value={formData.tokens}
                            onChange={handleChange}
                            min="0"
                          />
                        </Col>

                        {/* Interval */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Interval
                          </label>
                          <select
                            className="form-control"
                            name="interval"
                            value={formData.interval}
                            onChange={handleChange}
                          >
                            <option value="">Select Interval</option>
                            <option value="month">Month</option>
                            <option value="year">Year</option>
                          </select>
                          {errors.interval && (
                            <small className="text-danger">
                              {errors.interval}
                            </small>
                          )}
                        </Col>

                        {/* Interval Count */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Interval Count
                          </label>
                          <select
                            className="form-control"
                            name="intervalCount"
                            value={formData.intervalCount}
                            onChange={handleChange}
                            disabled={!formData.interval}
                          >
                            <option value="">
                              {!formData.interval
                                ? "Select Interval First"
                                : "Select Interval Count"}
                            </option>
                            {getIntervalCountOptions().map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          {errors.intervalCount && (
                            <small className="text-danger">
                              {errors.intervalCount}
                            </small>
                          )}
                        </Col>

                        {/* Payment Id */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Payment Id
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="stripePriceId"
                            placeholder="Enter Stripe Id"
                            value={formData.stripePriceId}
                            onChange={handleChange}
                          />
                        </Col>

                        {/* Status */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Status
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </Col>

                        {/* ── Translations ── */}
                        {/* <Col md="12" className="my-2">
                          <div className="topHead pb-2 mt-2">
                            <h6
                              className="m-0 fw-sbold"
                              style={{ color: "#2E3A59" }}
                            >
                              Translations
                            </h6>
                          </div>
                        </Col> */}

                        <Row className="mx-0">
                          {formData.translations.map((item, index) => (
                            <React.Fragment key={index}>
                              {index > 0 && (
                                <Col md="12" className="my-2">
                                  <hr />
                                </Col>
                              )}

                              {/* Plan Name */}
                              <Col md="6" className="my-2">
                                <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                                  Plan Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter plan name"
                                  value={item.name}
                                  onChange={(e) =>
                                    handleTranslationChange(
                                      index,
                                      "name",
                                      e.target.value,
                                    )
                                  }
                                />
                                {errors[`translations-${index}-name`] && (
                                  <small className="text-danger">
                                    {errors[`translations-${index}-name`]}
                                  </small>
                                )}
                              </Col>

                              {/* Badge */}
                              <Col md="6" className="my-2">
                                <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                                  Badge
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="e.g. Best Value"
                                  value={item.badge}
                                  onChange={(e) =>
                                    handleTranslationChange(
                                      index,
                                      "badge",
                                      e.target.value,
                                    )
                                  }
                                />
                              </Col>

                              {/* Benefits */}
                              <Col md="12" className="my-2">
                                <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                                  Benefits
                                </label>
                                {item.benifits.map((benifit, bIndex) => (
                                  <div
                                    key={bIndex}
                                    className="d-flex align-items-center mb-2"
                                  >
                                    <input
                                      type="text"
                                      className="form-control me-2"
                                      placeholder="Enter benefit"
                                      value={benifit}
                                      onChange={(e) =>
                                        handleBenifitChange(
                                          index,
                                          bIndex,
                                          e.target.value,
                                        )
                                      }
                                    />
                                    <Button
                                      variant="danger"
                                      className="btn-sm"
                                      onClick={() =>
                                        removeBenifit(index, bIndex)
                                      }
                                      disabled={item.benifits.length === 1}
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  className="mt-2 btn-sm"
                                  onClick={() => addBenifit(index)}
                                  type="button"
                                >
                                  Add More
                                </Button>
                              </Col>
                            </React.Fragment>
                          ))}
                        </Row>
                      </Row>
                    </div>
                  </div>

                  {/* Submit / Cancel */}
                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="text-uppercase fw-sbold w-100 btn-danger"
                            onClick={() => navigate("/subscription-setting")}
                            type="button"
                          >
                            Cancel
                          </Button>
                        </Col>
                        <Col md="7" className="my-2">
                          <Button
                            disabled={isDisabled}
                            type="submit"
                            className="text-uppercase fw-sbold w-100 btn-primary"
                          >
                            {isDisabled ? "Updating..." : "Update"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EditSubscription;
